export const PLATFORMS_CONFIG = {
    youtube: {
        name: 'YouTube',
        icon: 'fa-brands fa-youtube',
        color: 'bg-[#FF0000] text-white',
        uploadMode: 'CLIENT',
        titleRequired: true,
        maxChars: 5000,
        supportVideo: true,
        supportImage: false,
        allowPureText: false,
        video: {
            maxSize: 500 * 1024 * 1024,
            maxDuration: 43200, // 12h
            aspectRatio: '16:9',
            count: 1
        }
    },
    tiktok: {
        name: 'TikTok',
        icon: 'fa-brands fa-tiktok',
        color: 'bg-black text-white',
        uploadMode: 'CLIENT',
        titleRequired: false,
        maxChars: 2200,
        supportVideo: true,
        supportImage: false,
        allowPureText: false,
        video: {
            maxSize: 500 * 1024 * 1024,
            maxDuration: 600,
            aspectRatio: '9:16',
            count: 1
        },
    },
    instagram: {
        name: 'Instagram',
        icon: 'fa-brands fa-instagram',
        color: 'bg-pink-600 text-white',
        uploadMode: 'CLIENT',
        titleRequired: false,
        maxChars: 2200,
        supportVideo: true,
        supportImage: true,
        allowPureText: false,
        video: {
            maxSize: 100 * 1024 * 1024,
            maxDuration: 90,
            aspectRatio: '9:16',
            count: 1
        },
        image: {
            maxSize: 30 * 1024 * 1024,
            aspectRatio: '1:1',
            count: 4
        }
    },
    facebook: {
        name: 'Facebook',
        icon: 'fa-brands fa-facebook-f',
        color: 'bg-blue-600 text-white',
        uploadMode: 'CLIENT',
        titleRequired: false,
        maxChars: 63206,
        supportVideo: true,
        supportImage: true,
        allowPureText: true,
        video: {
            maxSize: 100 * 1024 * 1024,
            maxDuration: 14400,
            aspectRatio: 'any',
            count: 1
        },
        image: {
            maxSize: 30 * 1024 * 1024,
            aspectRatio: 'any',
            count: 4
        }
    },
    twitter: {
        name: 'X / Twitter',
        icon: 'fa-brands fa-x-twitter',
        color: 'bg-zinc-900 text-white',
        uploadMode: 'CLIENT',
        titleRequired: false,
        maxChars: 280,
        supportVideo: true,
        supportImage: true,
        allowPureText: true,
        video: {
            maxSize: 512 * 1024 * 1024,
            maxDuration: 140,
            aspectRatio: 'any',
            count: 1
        },
        image: {
            maxSize: 5 * 1024 * 1024,
            aspectRatio: 'any',
            count: 4
        }
    },
    linkedin: {
        name: 'LinkedIn',
        icon: 'fa-brands fa-linkedin-in',
        color: 'bg-blue-700 text-white',
        uploadMode: 'CLIENT',
        titleRequired: false,
        maxChars: 3000,
        supportVideo: true,
        supportImage: true,
        allowPureText: true,
        video: {
            maxSize: 200 * 1024 * 1024,
            maxDuration: 600,
            aspectRatio: 'any',
            count: 1
        },
        image: {
            maxSize: 10 * 1024 * 1024,
            aspectRatio: 'any',
            count: 4
        }
    },
    discord: {
        name: 'Discord',
        icon: 'fa-brands fa-discord',
        color: 'bg-indigo-500 text-white',
        uploadMode: 'SERVER',
        titleRequired: false,
        maxChars: 2000,
        supportVideo: false,
        supportImage: false,
        allowPureText: true,
        video: {
            maxSize: 25 * 1024 * 1024,
            maxDuration: 0,
            count: 10
        },
        image: {
            maxSize: 25 * 1024 * 1024,
            count: 4
        }
    },
    mastodon: {
        name: 'Mastodon',
        icon: 'fa-brands fa-mastodon',
        color: 'bg-purple-600 text-white',
        uploadMode: 'SERVER',
        titleRequired: false,
        maxChars: 500,
        support: ['video', 'image'],
        video: {
            maxSize: 40 * 1024 * 1024,
            maxDuration: 0,
            count: 1
        },
        supportVideo: false,
        supportImage: true,
        allowPureText: true,
        image: {
            maxSize: 10 * 1024 * 1024,
            count: 4
        }
    },
    bluesky: {
        name: 'bluesky',
        icon: 'fa-brands fa-bluesky',
        color: 'bg-blue-400 text-white',
        uploadMode: 'SERVER',
        titleRequired: false,
        maxChars: 300,
        supportVideo: true,
        supportImage: true,
        allowPureText: true,
        video: {
            maxSize: 50 * 1024 * 1024,
            maxDuration: 60,
            count: 1
        },
        image: {
            maxSize: 10 * 1024 * 1024,
            count: 4
        }
    },
    threads: {
        name: 'Threads',
        icon: 'fa-brands fa-threads',
        color: 'bg-zinc-950 text-white',
        uploadMode: 'CLIENT',
        supportVideo: true,
        supportImage: true,
        allowPureText: true,
        titleRequired: false,
        maxChars: 500,
        support: ['video', 'image'],
        video: {
            maxSize: 100 * 1024 * 1024,
            maxDuration: 300,
            aspectRatio: 'any',
            count: 1
        },
        image: {
            maxSize: 20 * 1024 * 1024,
            count: 4
        },
        video: {
            maxSize: 100 * 1024 * 1024,
            maxDuration: 300,
            aspectRatio: '9:16',
            count: 1
        },
    },
    telegram: {
        name: 'Telegram',
        icon: 'fa-brands fa-telegram',
        color: 'bg-blue-400 text-white',
        uploadMode: 'SERVER',
        supportVideo: true,
        supportImage: true,
        allowPureText: true,
        titleRequired: false,
        maxChars: 4096,
        support: ['video', 'image'],
        video: {
            maxSize: 50 * 1024 * 1024,
            maxDuration: 0,
            count: 10
        },
        image: {
            maxSize: 10 * 1024 * 1024,
            count: 4
        }
    },
    github: {
        name: 'GitHub',
        icon: 'fa-brands fa-github',
        color: 'bg-gray-800 text-white',
        uploadMode: 'SERVER',
        titleRequired: true,
        supportVideo: false,
        supportImage: true,
        allowPureText: true,
        maxChars: 65536,
        image: {
            maxSize: 10 * 1024 * 1024,
            count: 4
        }
    },
    pinterest: {
        name: 'Pinterest',
        icon: 'fa-brands fa-pinterest-p',
        color: 'bg-red-700 text-white',
        uploadMode: 'SERVER',
        titleRequired: false,
        maxChars: 500,
        supportVideo: true,
        supportImage: true,
        allowPureText: false,
        video: {
            maxSize: 50 * 1024 * 1024,
            maxDuration: 900,
            aspectRatio: '9:16',
            count: 1
        },
        image: {
            maxSize: 20 * 1024 * 1024,
            aspectRatio: '2:3',
            count: 1
        }
    }
};

export const getCommonLimits = (selectedPlatforms) => {
    if (!selectedPlatforms || selectedPlatforms.length === 0) {
        return {
            maxChars: 0,
            maxImages: 0,
            maxVideoSize: 0,
            maxVideoDuration: 0,
            supportVideo: false,
            supportImage: false,
            titleRequired: false,
            allowPureText: true
        };
    }

    let limits = {
        maxChars: Infinity,
        maxImages: Infinity,
        maxVideoSize: Infinity,
        maxVideoDuration: Infinity,
        supportVideo: true,
        supportImage: true,
        titleRequired: false,
        allowPureText: true
    };

    selectedPlatforms.forEach(platformKey => {
        const config = PLATFORMS_CONFIG[platformKey];
        if (!config) return;

        limits.maxChars = Math.min(limits.maxChars, config.maxChars || 0);

        if (config.titleRequired) limits.titleRequired = true;

        if (config.allowPureText === false) limits.allowPureText = false;

        if (config.supportImage) {
            limits.maxImages = Math.min(limits.maxImages, config.image?.count || 0);
        } else {
            limits.supportImage = false;
            limits.maxImages = 0;
        }

        if (config.supportVideo) {
            limits.maxVideoSize = Math.min(limits.maxVideoSize, config.video?.maxSize || 0);
            limits.maxVideoDuration = Math.min(limits.maxVideoDuration, config.video?.maxDuration || 0);
        } else {
            limits.supportVideo = false;
            limits.maxVideoSize = 0;
            limits.maxVideoDuration = 0;
        }
    });

    return {
        maxChars: limits.maxChars === Infinity ? 0 : limits.maxChars,
        maxImages: limits.maxImages === Infinity ? 0 : limits.maxImages,
        maxVideoSize: limits.maxVideoSize === Infinity ? 0 : limits.maxVideoSize,
        maxVideoDuration: limits.maxVideoDuration === Infinity ? 0 : limits.maxVideoDuration,
        titleRequired: limits.titleRequired,
        supportVideo: limits.supportVideo,
        supportImage: limits.supportImage,
        allowPureText: limits.allowPureText
    };
};

export const globalStore = {
    accounts: [],
    isDirty: true // 默认是 dirty（脏的），代表需要拉取更新
};